enum EUserTutorialStep
{
    Abort = -2,
    Closed = -1,
    New = 0,
}

export default EUserTutorialStep